/*
import {
  hf,
  ht,
  cr,
  gs,
  ls,
} from 'lib';
*/
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state

import * as icm from './icm';

import * as Iccv20 from './icvBaseS10Rz';

import * as icvI17To from './icvI17S10To';
import * as icvI17Co from './icvI17S10Co';

export const N = (pDz: {
}) => {

  const _gUserz = gs.useUserz();

  const _sPz = ls.usePagez({
    steps: [0],
    phs: 'dpy',
    lblz: icm.grtLblz({
      tgt: '備品・駐車場',
    })
  });

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _sPz.udt,
  });

  return (
    cr.c(Iccv20.N, {
      key: -10,
      cz: {
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            _sPz.crt.lblz.ttlz.top
          : _sPz.crt.steps[0] == 1 ?
            _sPz.crt.lblz.ttlz.ctt
          : ''
      },
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(icvI17To.O, {
          key: -10,
          sPz: _sPz,
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icvI17Co.O, {
          key: -20,
          sPz: _sPz,
        })
        : null,

      ]
    })
  );
};
